export default [
	{
		path: "/admin/approvals",
		exact: true,
		policy: "supportAdminAuth",
		component: "Approvals",
		mui: true,
	},
];
